import React from "react";

export const statusConfig = {
  pedido_protocolado: {
    label: "Pedido protocolado",
    descricao:
      "O pedido foi recebido e numerado pelo INPI. É o ponto de partida do processo.",
    className: "inpi-badge inpi-badge--protocolado",
  },
  exame_formal: {
    label: "Exame formal",
    descricao:
      "O INPI está verificando se a documentação está completa e correta.",
    className: "inpi-badge inpi-badge--andamento",
  },
  aguardando_oposicao: {
    label: "Aguard. oposição",
    descricao:
      "O pedido foi publicado na RPI e está dentro do prazo legal de 60 dias.",
    className: "inpi-badge inpi-badge--oposicao",
  },
  aguardando_manifestacao: {
    label: "Aguard. manifestação",
    descricao: "Uma oposição foi apresentada. O titular tem prazo para se manifestar.",
    className: "inpi-badge inpi-badge--manifestacao",
  },
  aguardando_merito: {
    label: "Aguard. mérito",
    descricao: "Aguarda o examinador analisar se atende aos requisitos legais.",
    className: "inpi-badge inpi-badge--merito",
  },
  deferido: {
    label: "Deferido",
    descricao: "O INPI aprovou o pedido! Registro concedido após análise completa.",
    className: "inpi-badge inpi-badge--deferido",
  },
  indeferido: {
    label: "Indeferido",
    descricao: "O INPI negou o pedido. Ainda é possível interpor recurso.",
    className: "inpi-badge inpi-badge--indeferido",
  },
  registro_ativo: {
    label: "Registro ativo",
    descricao: "O certificado de registro foi emitido e está em vigor.",
    className: "inpi-badge inpi-badge--ativo",
  },
  arquivado: {
    label: "Arquivado",
    descricao: "O processo foi encerrado sem concessão do registro.",
    className: "inpi-badge inpi-badge--arquivado",
  },
  pedido_inexistente: {
    label: "Pedido inexistente",
    descricao: "O INPI considerou o pedido como não existente.",
    className: "inpi-badge inpi-badge--inexistente",
  },
};

const STATUS_KEYS = Object.keys(statusConfig);

/**
 * Maps API status text (e.g. "Em exame", "Deferido") to statusConfig keys.
 * Aligned with client-webapp RegistrosInpi/StatusBadge.js.
 */
export function normalizeStatus(apiStatus) {
  if (!apiStatus) return "pedido_protocolado";
  const s = String(apiStatus).toLowerCase();
  if (STATUS_KEYS.includes(s)) return s;
  if (/protocolado|protocolo/.test(s)) return "pedido_protocolado";
  if (/exame\.formal|formal/.test(s)) return "exame_formal";
  if (/oposi[cç][aã]o|oposi/.test(s)) return "aguardando_oposicao";
  if (/manifesta[cç][aã]o/.test(s)) return "aguardando_manifestacao";
  if (/m[eé]rito|merito/.test(s)) return "aguardando_merito";
  // indeferido antes de deferido: "indeferido" contém "deferido"
  if (/indeferido/.test(s)) return "indeferido";
  if (/deferido/.test(s)) return "deferido";
  if (/registro\.ativo|ativo|certificado|em\.vigor|vigor/.test(s)) return "registro_ativo";
  if (/arquivado/.test(s)) return "arquivado";
  if (/inexistente/.test(s)) return "pedido_inexistente";
  if (/an[aá]lise|andamento|em\.exame/.test(s)) return "exame_formal";
  return "pedido_protocolado";
}

export function StatusBadge({ status }) {
  const key = normalizeStatus(status);
  const config = statusConfig[key] || statusConfig.pedido_protocolado;
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium whitespace-nowrap ${config.className}`}>
      <span className="inpi-badge-dot" />
      {config.label}
    </span>
  );
}
